import { useMutation } from '@tanstack/react-query';
import { HttpService } from '@Services/api/httpService';

interface SubmitSSNParams {
  customerId: string;
  phoneStateToken: string;
  answer: string;
}

interface SubmitSSNResponse {
  success: boolean;
  token: string;
}

export const useSubmitSSNMutation = () => {
  return useMutation<SubmitSSNResponse, Error, SubmitSSNParams>({
    mutationFn: async ({ customerId, phoneStateToken, answer }: SubmitSSNParams) => {
      const response = await HttpService.post<SubmitSSNResponse>(
        `v3/onboarding/secondary/${customerId}/question`,
        {
          stateToken: phoneStateToken,
          answer,
        }
      );
      return response.data;
    },
  });
};
